import { getDateParts } from './getDateParts';

const quarterMaps = [
    {
        quarter: '1',
        start: {
            month: '01',
            day: '01',
        },
        end: {
            month: '03',
            day: '31',
        },
    },
    {
        quarter: '2',
        start: {
            month: '04',
            day: '01',
        },
        end: {
            month: '06',
            day: '30',
        },
    },
    {
        quarter: '3',
        start: {
            month: '07',
            day: '01',
        },
        end: {
            month: '09',
            day: '30',
        },
    },
    {
        quarter: '4',
        start: {
            month: '10',
            day: '01',
        },
        end: {
            month: '12',
            day: '31',
        },
    },
];

/**
 * Returns a statement period label with the year first, like '2019 Q2', if the statement period
 * aligns with a calendar quarter. If not, returns an explicit date range, like
 * '1/15/2020 - 4/15/2020'. PRO statements are typically aligned to a calendar quarter, so this
 * should usually result in something like '2019 Q2'.
 */
export const getSortablePeriodLabels = (
    period?: Maybe<ProStatementPeriod>,
): SortablePeriodLabels => {
    const start = getDateParts(period?.start_date ?? null);
    const end = getDateParts(period?.end_date ?? null);

    const sortablePeriodLabels = {
        short: null,
        long: null,
    } as SortablePeriodLabels;

    if (start === null || end === null) {
        return sortablePeriodLabels;
    }

    const matchingQuarterMap = quarterMaps.find(
        (quarterMap: QuarterMap): boolean => {
            if (
                quarterMap.start.day === start.day &&
                quarterMap.start.month === start.month &&
                quarterMap.end.day === end.day &&
                quarterMap.end.month === end.month
            ) {
                return true;
            }

            return false;
        },
    );

    const quarter = matchingQuarterMap?.quarter ?? null;

    if (start.year === end.year && quarter !== null) {
        sortablePeriodLabels.short = `${end.year} Q${quarter}`;
    }

    sortablePeriodLabels.long = `${start.month}/${start.day}/${start.year} - ${end.month}/${end.day}/${end.year}`;

    return sortablePeriodLabels;
};
